import {
  heatingUsesCoal,
  heatingUsesDistrictHeating,
  heatingUsesGas,
  heatingUsesOil,
  heatingUsesPellet,
  heatingUsesWood
} from '@cfp/core';
import { BuildingMeasureSearchFacetsDTO, HeatingConsumptionTypeDTO } from 'csr-asset-app';

export function filterMeasureSearchFacetsByHeatingType(
  buildingMeasureSearchFacets: BuildingMeasureSearchFacetsDTO,
  heatingConsumptionType: HeatingConsumptionTypeDTO
): void {
  if (heatingUsesGas(heatingConsumptionType)) {
    delete buildingMeasureSearchFacets.oilConsumptionReductionRange;
    delete buildingMeasureSearchFacets.heatConsumptionReductionRange;
    delete buildingMeasureSearchFacets.coalConsumptionReductionRange;
    delete buildingMeasureSearchFacets.woodConsumptionReductionRange;
    delete buildingMeasureSearchFacets.pelletConsumptionReductionRange;
    return;
  }
  if (heatingUsesDistrictHeating(heatingConsumptionType)) {
    delete buildingMeasureSearchFacets.oilConsumptionReductionRange;
    delete buildingMeasureSearchFacets.gasConsumptionReductionRange;
    delete buildingMeasureSearchFacets.coalConsumptionReductionRange;
    delete buildingMeasureSearchFacets.woodConsumptionReductionRange;
    delete buildingMeasureSearchFacets.pelletConsumptionReductionRange;
    return;
  }
  if (heatingUsesOil(heatingConsumptionType)) {
    delete buildingMeasureSearchFacets.heatConsumptionReductionRange;
    delete buildingMeasureSearchFacets.gasConsumptionReductionRange;
    delete buildingMeasureSearchFacets.coalConsumptionReductionRange;
    delete buildingMeasureSearchFacets.woodConsumptionReductionRange;
    delete buildingMeasureSearchFacets.pelletConsumptionReductionRange;
    return;
  }
  if (heatingUsesCoal(heatingConsumptionType)) {
    delete buildingMeasureSearchFacets.heatConsumptionReductionRange;
    delete buildingMeasureSearchFacets.gasConsumptionReductionRange;
    delete buildingMeasureSearchFacets.oilConsumptionReductionRange;
    delete buildingMeasureSearchFacets.woodConsumptionReductionRange;
    delete buildingMeasureSearchFacets.pelletConsumptionReductionRange;
    return;
  }
  if (heatingUsesWood(heatingConsumptionType)) {
    delete buildingMeasureSearchFacets.heatConsumptionReductionRange;
    delete buildingMeasureSearchFacets.gasConsumptionReductionRange;
    delete buildingMeasureSearchFacets.oilConsumptionReductionRange;
    delete buildingMeasureSearchFacets.coalConsumptionReductionRange;
    delete buildingMeasureSearchFacets.pelletConsumptionReductionRange;
    return;
  }
  if (heatingUsesPellet(heatingConsumptionType)) {
    delete buildingMeasureSearchFacets.heatConsumptionReductionRange;
    delete buildingMeasureSearchFacets.gasConsumptionReductionRange;
    delete buildingMeasureSearchFacets.oilConsumptionReductionRange;
    delete buildingMeasureSearchFacets.coalConsumptionReductionRange;
    delete buildingMeasureSearchFacets.woodConsumptionReductionRange;
  }
}
